// tempexp_36140_file
import { FC, useCallback } from 'react';

import Analytics, { ElementShownAnchor } from '@hh.ru/analytics-js';
import { useExperimentCheckOnElementShown } from '@hh.ru/front-static-app';
import { Card, Link, Text, useBreakpoint } from '@hh.ru/magritte-ui';
import { ChevronRightOutlinedSize24 } from '@hh.ru/magritte-ui/icon';
import VSpacing from 'bloko/blocks/vSpacing';

import RefundModalExp from 'src/components/Employer/RefundModalExp';
import {
    EXPERIMENT_NAME_REFUND_FOR_NEW_EMPLOYER,
    useRefundForNewEmployer,
} from 'src/components/Price/hooks/useRefundForNewEmployer';
import { useOnOffState } from 'src/hooks/useOnOffState';
import { useSelectorNonNullable } from 'src/hooks/useSelector';
import { ServiceCode, ServiceItemCode } from 'src/models/price/productCodes';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

import styles from './price-cart-exp-banner.less';

const PriceCartExpBanner: FC = () => {
    const products = useSelectorNonNullable(({ priceCart }) => priceCart.products);
    // Показываем баннер только когда в корзине есть публикации Стандарт, Стандарт плюс или Премиум
    const hasNonAnonymousPublication = products.some((product) => {
        const isNonAnonymous =
            !!product.products &&
            Object.values(product.products).some(
                (item) =>
                    item.code === ServiceItemCode.Standart ||
                    item.code === ServiceItemCode.StandartPlus ||
                    item.code === ServiceItemCode.Premium
            );
        return product.code === ServiceCode.LimitedVacancy && isNonAnonymous;
    });
    const { isRefundForNewEmployerEnabled, shouldCheckRefundForNewEmployerExp } = useRefundForNewEmployer();
    const [visible, visibleOn, visibleOff] = useOnOffState(false);
    const { isMobile, isGtS } = useBreakpoint();
    const ref = useExperimentCheckOnElementShown({
        experimentNames: [EXPERIMENT_NAME_REFUND_FOR_NEW_EMPLOYER],
        sendCheck: shouldCheckRefundForNewEmployerExp && hasNonAnonymousPublication,
    });
    const handleClickMore = useCallback(() => {
        Analytics.sendHHEventButtonClick('banner_refund_more_cart_price');
        visibleOn();
    }, [visibleOn]);

    const mobileCardProps = isMobile
        ? {
              onClick: handleClickMore,
          }
        : {};

    return (
        <div ref={ref}>
            {isRefundForNewEmployerEnabled && hasNonAnonymousPublication ? (
                <ElementShownAnchor
                    fn={(element) =>
                        Analytics.sendHHEventElementShown(element, {
                            elementName: 'banner_refund_cart_price',
                        })
                    }
                >
                    <Card {...mobileCardProps} padding={12} borderRadius={12} style="special-secondary" stretched>
                        <div className={styles.cartFooterBanner}>
                            <Text style="primary" typography="label-3-regular">
                                Вернём деньги за первую вакансию, если она наберёт мало откликов
                                {isGtS && (
                                    <>
                                        <span>.</span>
                                        {REGULAR_SPACE}
                                        <Link
                                            Element="a"
                                            style="neutral"
                                            typography="label-3-regular"
                                            inline
                                            enableVisited={false}
                                            underlined
                                            onClick={handleClickMore}
                                        >
                                            Подробнее
                                        </Link>
                                    </>
                                )}
                            </Text>
                            {isMobile && (
                                <div className={styles.cartFooterIcon}>
                                    <ChevronRightOutlinedSize24 initialColor="secondary" />
                                </div>
                            )}
                        </div>
                    </Card>
                    <VSpacing base={4} />
                    <RefundModalExp visible={visible} onClose={visibleOff} />
                </ElementShownAnchor>
            ) : null}
        </div>
    );
};

export default PriceCartExpBanner;
